// this line is added because in this version of react we still need those imports even they are unused

import React from 'react'
import PortalCharger from 'pages/portal/Charger'
import PortalDocuments from 'pages/portal/Documents'
import PortalInstallationAssistant from 'pages/portal/InstallationAssistant'
import PortalOverview from 'pages/portal/Overview'
import PortalPayment from 'pages/portal/Payment'
import PortalProfile from 'pages/portal/Profile'
import PortalSupport from 'pages/portal/Support'
import PortalTariff from 'pages/portal/Tariff'
import PortalPayout from 'pages/portal/Payout'
import PortalFleetData from 'pages/portal/FleetData'
import { Navigate, Route, Routes as ReactRoutes } from 'react-router-dom'
import { routePaths } from './route_paths'
import ChargingCardsPage from 'pages/portal/ChargingCardsPage'

function Routes() {
  return (
    <ReactRoutes>
      <Route path={routePaths.portalOverview} element={<PortalOverview />} />
      <Route
        path={'/de-DE'}
        element={<Navigate to={routePaths.portalOverview} replace />}
      />
      <Route
        path={'/en-DE'}
        element={<Navigate to={routePaths.portalOverview} replace />}
      />

      <Route path={routePaths.portalCharger} element={<PortalCharger />} />
      <Route
        path={`/de-DE${routePaths.portalCharger}`}
        element={<Navigate to={routePaths.portalCharger} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalCharger}`}
        element={<Navigate to={routePaths.portalCharger} replace />}
      />

      <Route path={routePaths.portalDocuments} element={<PortalDocuments />} />
      <Route
        path={`/de-DE${routePaths.portalDocuments}`}
        element={<Navigate to={routePaths.portalDocuments} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalDocuments}`}
        element={<Navigate to={routePaths.portalDocuments} replace />}
      />

      <Route path={routePaths.portalSupport} element={<PortalSupport />} />
      <Route
        path={`/de-DE${routePaths.portalSupport}`}
        element={<Navigate to={routePaths.portalSupport} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalSupport}`}
        element={<Navigate to={routePaths.portalSupport} replace />}
      />

      <Route path={routePaths.portalProfile} element={<PortalProfile />} />
      <Route
        path={`/de-DE${routePaths.portalProfile}`}
        element={<Navigate to={routePaths.portalProfile} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalProfile}`}
        element={<Navigate to={routePaths.portalProfile} replace />}
      />

      <Route path={routePaths.portalPayment} element={<PortalPayment />} />
      <Route
        path={`/de-DE${routePaths.portalPayment}`}
        element={<Navigate to={routePaths.portalPayment} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalPayment}`}
        element={<Navigate to={routePaths.portalPayment} replace />}
      />

      <Route
        path={routePaths.portalPhotoUpload}
        element={<PortalInstallationAssistant />}
      />

      <Route path={routePaths.portalTariff} element={<PortalTariff />} />
      <Route
        path={`/de-DE${routePaths.portalTariff}`}
        element={<Navigate to={routePaths.portalTariff} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalTariff}`}
        element={<Navigate to={routePaths.portalTariff} replace />}
      />

      <Route path={routePaths.portalPayout} element={<PortalPayout />} />
      <Route
        path={`/de-DE${routePaths.portalPayout}`}
        element={<Navigate to={routePaths.portalPayout} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalPayout}`}
        element={<Navigate to={routePaths.portalPayout} replace />}
      />

      <Route path={routePaths.portalFleetData} element={<PortalFleetData />} />
      <Route
        path={`/de-DE${routePaths.portalFleetData}`}
        element={<Navigate to={routePaths.portalFleetData} replace />}
      />
      <Route
        path={`/en-DE${routePaths.portalFleetData}`}
        element={<Navigate to={routePaths.portalFleetData} replace />}
      />

      <Route
        path={routePaths.portalCards}
        element={<ChargingCardsPage />}
      ></Route>

      {/* Legacy auth URLs — redirect to portal; AuthProvider handles unauthenticated users */}
      <Route
        path={routePaths.login}
        element={<Navigate to={routePaths.portalOverview} replace />}
      />
      <Route
        path={routePaths.resetPassword}
        element={<Navigate to={routePaths.portalOverview} replace />}
      />
      <Route
        path={routePaths.resetPasswordFirstTime}
        element={<Navigate to={routePaths.portalOverview} replace />}
      />

      <Route path="*" element={<Navigate to={routePaths.portalOverview} replace />} />
    </ReactRoutes>
  )
}

export default Routes
